module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('x-dialog', {
    attrs: {
      "mask-close": _vm.maskClose,
      "can-scroll": _vm.canScroll
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    ref: "dialogContent",
    staticClass: "ssui-dialog",
    class: {
      'ssui-dialog--no-title': !_vm.title
    }
  }, [_c('div', {
    staticClass: "ssui-dialog__hd"
  }, [(_vm.title) ? _c('span', {
    staticClass: "ssui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.hasClose) ? _c('div', {
    staticClass: "ssui-dialog__close",
    on: {
      "click": function($event) {
        _vm.showValue = false
      }
    }
  }, [_c('div')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ssui-dialog__bd"
  }, [_c('div', [_vm._t("default")], 2)]), _vm._v(" "), (_vm.hasBtn) ? _c('div', {
    staticClass: "ssui-dialog__ft",
    class: {
      'ssui-dialog__ft--double-btn': _vm.isDoubleBtn
    }
  }, [(_vm.isDoubleBtn) ? _c('x-button', {
    attrs: {
      "type": "small:secondary"
    },
    on: {
      "btn-click": function($event) {
        _vm.$emit('on-cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "small:main"
    },
    on: {
      "btn-click": function($event) {
        _vm.$emit('on-confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])], 1) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2285d643", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2285d643"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@finance/ssvue/src/components/confirm/index.vue
// module id = 255
// module chunks = 8